import _ from 'lodash';

// The Table block a legacy Ranking Matrix ("Matrix (% of total, Rank)")
// opens as: a row per term of its field, every row shown, with each
// metric's rank and share of the total. Once edited it saves as a V5 matrix,
// which ranks and shares out its rows the same way (addRankAndPercentageOfTotal).
// Undefined for one Studio can't show yet: one without metrics, or one
// grouped by a date field (the matrix's date rows are its metrics' dates,
// not another date field's).
export const guessRankingTableCard = (
  chartDef: VisualisationDefinitions.RankingMatrix,
): Studio.GadgetSidecarCard | undefined => {
  const { metrics, sorting } = chartDef;
  if (metrics.length === 0 || chartDef.interval) {
    return undefined;
  }
  const metricIds = metrics.map((m) => m.metricId);
  const metricOptions = _.omitBy(
    _.fromPairs(
      metrics.map((m) => [
        m.metricId,
        _.omitBy(
          {
            displayName: m.displayName || undefined,
            isRankEnabled: m.isRankingEnabled || undefined,
            isPercentageOfTotalEnabled:
              m.isPercentageOfTotalEnabled || undefined,
            percentageOfTotalPrecision: m.isPercentageOfTotalEnabled
              ? m.percentageOfTotalPrecision
              : undefined,
          },
          _.isUndefined,
        ) as Studio.TableMetricOptions,
      ]),
    ),
    _.isEmpty,
  );
  const sort: Studio.TableSort =
    sorting.mode === 'alphabetical'
      ? { by: 'dimension', direction: sorting.order }
      : {
          by: 'metric',
          metricId: sorting.metricId ?? metricIds[0],
          direction: sorting.order,
        };
  const table: Studio.TableOptions = {
    sort,
    ...(chartDef.gridSizing && chartDef.gridSizing !== 'fitGadget'
      ? { gridSizing: chartDef.gridSizing }
      : {}),
    ...(_.isEmpty(metricOptions) ? {} : { metrics: metricOptions }),
  };
  return {
    visType: 'table',
    metricIds,
    name: chartDef.name,
    ...(chartDef.description ? { description: chartDef.description } : {}),
    dimensions: [chartDef.groupByField],
    table,
  };
};
